import { inject, Service } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { MngSessionExpiredDialogComponent } from './mng-session-expired-dialog.component';
import { MngUserService } from './mng-user.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

export interface ISessionHandlerParams {
  onSessionTimeoutHandler?: OnSessionTimeoutHandler;
  sessionExpiredResolver?: SessionExpiredResolver;
  cookieCheckHandler?: CookieCheckHandler;
  intervalInMs?: number;
  cookieName?: string;
  dialogInfoText?: string;
  forceStart?: boolean;
}

export const defaultSessionHandlingParams: ISessionHandlerParams = {
  intervalInMs: 10000,
  forceStart: false
};

export type OnSessionTimeoutHandler = () => void;

// Logik für Session Handling beruht darauf dass ein Cookie NICHT mehr vorhanden ist
// -> wenn die App aber einfach offen bleibt und keine Interaktion passiert dann verschwindet das
// cookie aber nicht sofort, auch wenn es schon expired ist, deshalb kann da eine zusätzliche Logik
// implmentiert werden die prüft ob das Cookie für das Session Handling noch gültig ist
export type CookieCheckHandler = (cookieValue: string) => boolean;

export type SessionExpiredResolver = () => Promise<boolean>;

@Service()
export class MngSessionHandlerService {
  timeoutHandle;

  onSessionTimeoutHandler: OnSessionTimeoutHandler;
  cookieCheckHandler: CookieCheckHandler;
  sessionExpiredResolver: SessionExpiredResolver;

  showExpiredSessionInfo = true;

  cookieName = 'merkur_user_session_id';
  dialogInfoText: string | undefined;

  readonly cookieService = inject(CookieService);
  readonly dialog = inject(MatDialog);
  private readonly userService = inject(MngUserService);

  startSessionHandling(params: Partial<ISessionHandlerParams> = {}) {
    const values = { ...defaultSessionHandlingParams, ...params };

    this.cookieCheckHandler = values.cookieCheckHandler;
    this.sessionExpiredResolver = values.sessionExpiredResolver;

    if (values.cookieName) {
      this.cookieName = values.cookieName;
    }
    this.dialogInfoText = values.dialogInfoText;

    if (this.userService.getUserContextData() || values.forceStart) {
      console.log('Session-Handling gestartet mit Intervall von ', values.intervalInMs, 'ms');
      this.onSessionTimeoutHandler = values.onSessionTimeoutHandler;
      this.timeoutHandle = setInterval(() => {
        void this.checkSession();
      }, values.intervalInMs);
    }
  }

  async checkSession() {
    let sessionExpired = false;
    // console.log('checkSession');
    if (this.sessionExpiredResolver) {
      sessionExpired = await this.sessionExpiredResolver();
    } else {
      sessionExpired = !this.cookieService.get(this.cookieName);
      if (!sessionExpired && this.cookieCheckHandler) {
        sessionExpired = this.cookieCheckHandler(this.cookieService.get(this.cookieName));
      }
    }

    if (sessionExpired) {
      clearTimeout(this.timeoutHandle);
      if (this.onSessionTimeoutHandler) {
        this.onSessionTimeoutHandler();
      }

      if (this.showExpiredSessionInfo) {
        this.showOverlay();
      }
    }
  }

  stopSessionHandling() {
    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }
  }

  showOverlay() {
    const dialogConfig: MatDialogConfig = {
      width: '800px',
      hasBackdrop: true,
      disableClose: true,
      data: { infoText: this.dialogInfoText }
    };
    this.dialog.open(MngSessionExpiredDialogComponent, dialogConfig);
  }
}
